// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__3DL_F","button":"button__39Q0P","active":"active__g4APf button__39Q0P","single":"single__Zv0xD","icon":"icon__14ulX"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/styles/checkbox.scss
// module id = gtp/
// module chunks = 0